import { render, staticRenderFns } from "./EditProfileSidebar.vue?vue&type=template&id=1d409bcc&scoped=true&"
import script from "./EditProfileSidebar.vue?vue&type=script&lang=js&"
export * from "./EditProfileSidebar.vue?vue&type=script&lang=js&"
import style0 from "./EditProfileSidebar.vue?vue&type=style&index=0&id=1d409bcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d409bcc",
  null
  
)

export default component.exports